import { toPoints} from '@/shared/helpers'
export const TABLE_COLUMNS = [
  {
    Header: "Created",
    accessor: "created",
  },
  {
    Header: "Program",
    accessor: "program",
  },
  {
    Header: "Referrer",
    accessor: "referrer",
  },
  {
    Header: "Referrer Email",
    accessor: "referrer_email",
  },
  {
    Header: "Referree",
    accessor: "referree",
  },
  {
    Header: "Referree Email",
    accessor: "referree_email",
  },
  {
    Header: "Message",
    accessor: "message",
  },
  {
    Header: "Category",
    accessor: "category",
  },
];
